module.exports = __webpack_public_path__ + "static/img/pj-top-bg.edd5d21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/pj-top-bg.png
// module id = Rc5w
// module chunks = 167